export function getApproveButtonText(
	pending: boolean,
	needApprove: boolean
): string {
	if (pending) {
		return 'Approving....'
	}

	if (needApprove) {
		return 'Approve SIS Amount'
	}

	return 'Amount Approved'
}

export function getCreateButtonText(
	pending: boolean,
	needApprove: boolean
): string {
	if (pending) {
		return 'Creating....'
	}

	if (needApprove) {
		return 'You need approve SIS amount'
	}

	return 'Create Lock'
}
